module.exports = __webpack_public_path__ + "assets/images/af6a7dbe0ec189165118d70fe22406b4.png";